<template>
	<div class="orderpage">
		<common-header></common-header>
		<div class="text-left flex border-top">
			<div class="left-menu">
				<ul class="side-nav">
					<li class="nav-item">
						<a>个人中心</a>
						<ul>
							<li class="nav-item"><el-link @click="toPage('/userManage')">个人中心</el-link></li>
						</ul>
					</li>
					<li class="nav-item">
						<a>我的钱包</a>
						<ul>
							<li class="nav-item"><el-link @click="toPage('/userManage/couponList')">优惠券</el-link></li>
						</ul>
					</li>
					<li class="nav-item">
						<a>我的关注</a>
						<ul>
							<li class="nav-item"><el-link @click="toPage('/userManage/collect')">商品收藏</el-link></li>
						</ul>
					</li>
					<li class="nav-item">
						<a>订单中心</a>
						<ul>
							<li class="nav-item"><el-link @click="toPage('/order', 'state=1')">待付款</el-link></li>
							<li class="nav-item"><el-link @click="toPage('/order', 'state=2')">待发货</el-link></li>
							<li class="nav-item"><el-link @click="toPage('/order', 'state=3')">待评价</el-link></li>
							<li class="nav-item"><el-link @click="toPage('/order', 'state=4')">退款售后</el-link></li>
						</ul>
					</li>
				</ul>
			</div>
			<div class="right-container">
				<div class="page-title backcolor padding">账户信息</div>
				<div class="order-container">
					<div class="backcolor" style="padding: 15px;">
						<el-form :model="form" :rules="rules" ref="userFrom" label-width="100px" class="demo-form">
							<el-tabs type="">
								<el-tab-pane label="基本信息">
									<div style="margin-bottom: 10px;"><el-button type="primary" size="mini" @click="uploadHeaderPic">上传头像图片</el-button></div>
									<img v-if="form.headerpic" class="headerpic" :src="getWebPic(form.headerpic)" alt="" />
									<el-upload
										id="iviewUp"
										ref="iviewUp"
										:show-upload-list="false"
										:on-success="handleSingleSuccess"
										:format="['jpg', 'jpeg', 'png']"
										:max-size="2048"
										type="drag"
										:action="HOST + '/home.user/uploadHeaderPic'"
										:data="{ userid: userInfo.id, token: userInfo.token }"
										style="display: none;width:0"
									></el-upload>
									<el-form-item label="用户昵称" prop="nickname"><el-input v-model="form.nickname"></el-input></el-form-item>
									<el-form-item label="性别" prop="sex">
										<el-radio-group v-model="form.sex" @change="sexChange">
											<el-radio :label="1">
												<i class="el-icon-male"></i>
												男士
											</el-radio>
											<el-radio :label="2">
												<i class="el-icon-famale"></i>
												女士
											</el-radio>
										</el-radio-group>
									</el-form-item>
									<el-form-item label="生日" prop="birthday">
										<el-date-picker v-model="form.birthday" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
									</el-form-item>
								</el-tab-pane>
								<el-tab-pane label="隐私信息">
									<el-form-item label="真实姓名" prop="realname"><el-input v-model="form.realname"></el-input></el-form-item>
									<el-form-item label="手机号码" prop="tel"><el-input v-model="form.tel"></el-input></el-form-item>
								</el-tab-pane>
							</el-tabs>
							<el-form-item>
								<el-button type="primary" @click="submitForm('userFrom')">立即修改</el-button>
								<el-button>取消</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import commonHeader from '../../components/common/commonHeader.vue';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
	name: '',
	components: {
		commonHeader
	},
	data() {
		return {
			form: {},
			rules: {
				nickname: [{ required: true, message: '请输入用户昵称', trigger: 'blur' }, { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }]
			}
		};
	},
	computed: {
		...mapState({
			loginState: state => state.user.loginState,
			userInfo: state => JSON.parse(state.user.userInfo)
		})
	},
	mounted() {
		this.form = JSON.parse(JSON.stringify(this.userInfo));
	},
	methods: {
		...mapMutations({
			setUserInfo: 'user/setUserInfo'
		}),
		sexChange(e) {
			console.log(e);
			// this.userInfo.sex = e;
		},
		uploadHeaderPic() {
			document.querySelector('#iviewUp input').click();
		},
		handleSingleSuccess(res, file) {
			if (res.length) {
				this.form.headerpic = res;
				this.setUserInfo(this.form);
			} else {
				this.$message.error('图片格式不正确，请重试');
			}
		},
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.changeUserInfo();
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		changeUserInfo(){
			this.$emit('showLoading',true);
			this.form.userid = this.userInfo.id;
			this.form.token = this.userInfo.token;
			this.$request.post('/home.user/changeUserInfo',this.form)
			.then(res=>{
				this.$emit('showLoading',false);
				if (res.data.status == 0) {
					this.$message.error(res.data.msg);
					if (res.data.admin_err == 'userinfo_error') {
						this.exit().then(res => {
							console.log(res);
							if (res.actionStatus == 1) {
								this.$router.push('/login');
							}
						});
					}
				} else {
					this.$message.success(res.data.msg);
					this.setUserInfo(this.form);
				}
			})
			.catch(err=>{
				this.$emit('showLoading',false);
			})
		}
	}
};
</script>
<style lang="scss">
.el-main {
	.orderpage {
		background-color: #f0f3ef !important;
	}
	.left-menu {
		width: 170px;
		background-color: #fff;
		.side-nav {
			> .nav-item {
				padding: 15px 20px;
				border-bottom: 1px solid #f3f3f3;
				a {
					font-size: 15px;
					font-weight: bold;
					text-decoration: none;
					line-height: 40px;
				}
				.nav-item {
					a {
						font-size: 14px;
						line-height: 30px;
						&:hover {
							cursor: pointer;
						}
					}
				}
			}
		}
	}
	.right-container {
		flex: 1;
		padding: 20px 0 0 20px;
		background-color: #f0f3ef !important;
		.backcolor {
			background-color: #fff;
		}
		.padding {
			padding: 0 15px;
		}
		.page-title {
			line-height: 40px;
		}
		.order-container {
			margin-top: 15px;
			// margin-left: 15px;
			.menu-btn {
				button {
					color: dimgray;
					padding: 0 10px;
					line-height: 35px;
					&:hover {
						color: $base-color;
					}
					&.active {
						color: $base-color;
						border-bottom: 2px solid $base-color;
					}
				}
			}
			.order-item {
				margin-top: 10px;
				border: 1px solid #dddddd;
				.th {
					background-color: #e1e1e1;
					font-size: 14px;
					line-height: 35px;
					span + span {
						margin-left: 15px;
					}
				}
				.item-border {
					> div {
						border-right: 1px solid #dddddd;
						padding-top: 15px;
						text-align: center;
						&:first-child {
							padding: 0 15px;
							text-align: left;
						}
						&:first-child {
							padding-top: 0;
						}
						&:last-child {
							border-right: none;
						}
					}
				}
				.goods-info {
					flex: 1;
					.goods-item {
						border-bottom: 1px solid #dddddd;
						&:last-child {
							border: none;
						}
						padding: 15px 0;
						.smpic {
							width: 60px;
							height: 60px;
						}
						.goods-title {
							flex: 1;
							padding-left: 15px;
						}
						.param-num {
							padding: 0 15px;
							text-align: center;
							color: gray;
							font-size: 14px;
							line-height: 30px;
							.num {
								&::before {
									content: 'x';
									margin-right: 3px;
								}
							}
						}
					}
				}

				.user-address {
					width: 85px;
					line-height: 30px;
					&:hover {
						cursor: pointer;
					}
				}
				.order-pay {
					width: 90px;
					line-height: 30px;
					text-align: center;
					.pay {
						border-bottom: 1px solid #ccc;
						&::before {
							content: '￥';
						}
					}
				}
				.order-status {
					width: 82px;
				}
				.operate {
					width: 120px;
					text-align: center;
					.chaoshi_tip {
						font-size: 13px;
						color: #cccccc;
					}
					.block {
						display: block;
						+ .block {
							margin-top: 10px;
						}
					}
				}
			}
		}
	}
	.border-top {
		border-top: 1px solid #f3f3f3;
	}
	.headerpic {
		width: 150px;
		height: 150px;
		border: 1px solid #ccc;
	}
}
</style>
